module.exports = {
	init: function () {
    $('.count').countUp();
        // document.querySelectorAll('.count').forEach(counter => {
        //     const countUp = new CountUp(counter, parseInt(counter.dataset.number), { enableScrollSpy: true });
        //     if (!countUp.error) {
        //         countUp.start();
        //       } else {
        //         console.error(countUp.error);
        //       }
        // });
    }
}
